import React from "react";

import cx from "classnames";

import stylesFeedbackCard from "~/feedback/FeedbackList/css/FeedbackCard.module.css";

import styles from "./css/ListHeader.module.css";

export default function ListHeader({ className }: { className?: string }) {
	return (
		<div className={cx(styles.header, stylesFeedbackCard.grid, className)}>
			<div className={styles.dot} />
			<div>Topic</div>
			<div>Status</div>
			<div>Responses</div>
			<div>Last Updated</div>
			<div>Author</div>
			<div />
		</div>
	);
}
